import { GlobalResponseObject } from "../common";

export class BundleScanModel {
    style: string;
    color: string;
    dcNo: string;
    size: string;
    destination: string;
    po: string;
    barcodeId: string;
    dateTime: string;
    operation: string;

    constructor(
        style: string,
        color: string,
        dcNo: string,
        size: string,
        destination: string,
        po: string,
        barcodeId: string,
        dateTime: string,
        operation: string
    ) {
        this.style = style;
        this.color = color;
        this.dcNo = dcNo;
        this.size = size;
        this.destination = destination;
        this.po = po;
        this.barcodeId = barcodeId;
        this.dateTime = dateTime;
        this.operation = operation;
    }
}